var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AddBox, Clear, IndeterminateCheckBox } from '@material-ui/icons';
import { Field } from 'formik';
import React, { useRef } from 'react';
import { HoverIconButton, IconWrapper, NoSpinInput, Wrapper, } from './CustomFormikNumberField.Styles';
export var CustomFormikNumberField = function (props) {
    var inputFieldRef = useRef(null);
    var clear = props.clear && (props.value + '').length > 0;
    return (React.createElement(Wrapper, { fullWidth: props.fullWidth, half: props.half },
        React.createElement(Field, __assign({ placeholder: props.label }, props, { component: NoSpinInput, clear: clear, type: 'number', variant: 'outlined', margin: 'dense', innerRef: inputFieldRef, InputLabelProps: __assign({ shrink: true }, props.InputLabelProps), InputProps: __assign({ notched: false }, props.InputProps) })),
        React.createElement(IconWrapper, null,
            clear && (React.createElement(HoverIconButton, { size: 'small', disableFocusRipple: true, onClick: function () {
                    inputFieldRef.current.updateValue('');
                } },
                React.createElement(Clear, { fontSize: 'medium' }))),
            React.createElement(HoverIconButton, { size: 'small', disableFocusRipple: true, onClick: function () {
                    var value = parseInt(inputFieldRef.current.value || 0);
                    if (props.min === undefined || value > props.min) {
                        inputFieldRef.current.updateValue(--value);
                    }
                } },
                React.createElement(IndeterminateCheckBox, { fontSize: 'medium' })),
            React.createElement(HoverIconButton, { size: 'small', disableFocusRipple: true, onClick: function () {
                    var value = parseInt(inputFieldRef.current.value || 0);
                    if (props.max === undefined || value < props.max) {
                        inputFieldRef.current.updateValue(++value);
                    }
                } },
                React.createElement(AddBox, { fontSize: 'medium' })))));
};
//# sourceMappingURL=CustomFormikNumberField.js.map